// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"e869701c","408":"48b8a0d9"}[chunkId] + ".chunk.js";
};